export default __webpack_public_path__ + "static/media/clockofficon.39f13f20.svg";